module.exports = __webpack_public_path__ + "img/i07.6dbef68e.svg";